import React from "react";
import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";
import { FaGavel } from "react-icons/fa";
import { motion } from "framer-motion";
import { margin } from "@mui/system";
import "../Services.css"; // Assuming you have a CSS file for styles

function Payroll() {
  // รายการบริการ
  const services = [
    {
      title: "บริการจัดทำบัญชี",
      desc: "เราให้บริการจัดทำบัญชีที่มีคุณภาพและเชื่อถือได้ เพื่อช่วยให้ธุรกิจของคุณสามารถมุ่งเน้นไปที่การเติบโตและการพัฒนา โดยไม่ต้องกังวลเกี่ยวกับการจัดการบัญชีและภาษี",
      img: require("../../../image/services/accounting.webp"),
    },
    {
      title: "บริการจัดทำเงินเดือน",
      desc: "เราให้บริการจัดทำเงินเดือนอย่างมืออาชีพ เพื่อให้คุณสามารถมุ่งเน้นที่การเติบโตของธุรกิจได้",
      img: require("../../../image/services/payroll.webp"),
    },
  ];

  // สุ่มเลือก 3 รายการ โดยไม่รวมบริการของหน้าปัจจุบัน
  function getRandomServices(arr, n, excludeTitle) {
    const filtered = arr.filter((s) => s.title !== excludeTitle);
    const shuffled = filtered.slice().sort(() => 0.5 - Math.random());
    return shuffled.slice(0, n);
  }
  const randomServices = getRandomServices(services, 1, "บริการจัดทำเงินเดือน");

  return (
    <div
      style={{
        background: "#f8f9fa",
        minHeight: "100vh",
        paddingTop: 0,
        paddingBottom: 48,
        fontFamily: "Prompt, sans-serif",
      }}
    >
      <section
        className="hero-section"
        style={{
          fontFamily: "Prompt, sans-serif",
          background: `linear-gradient(rgba(30, 30, 30, 0.2), rgba(30,30,30,0.2)), url(${require("../../../image/services/payroll.webp")}) center center/cover no-repeat`,
        }}
      >
        <div className="hero-content">
          <h1
            className="hero-title"
            style={{ marginTop: "80px", color: "rgba(255, 75, 75, 1)" }}
          >
            {" "}
            บริการจัดทำเงินเดือน
          </h1>
          <p
            className="hero-subtitle"
            style={{ color: "rgba(255, 255, 255, 1)" }}
          >
            เราให้บริการจัดทำเงินเดือนอย่างมืออาชีพ
            เพื่อให้คุณสามารถมุ่งเน้นที่การเติบโตของธุรกิจได้
          </p>
        </div>
      </section>
      {/* Breadcrumbs Section - Red Tone */}
      <Container fluid="md" style={{ marginTop: 0 }}>
        <Row className="justify-content-center">
          <Col xs={120} md={110} lg={100} xl={90} xxl={80}>
            <motion.nav
              aria-label="breadcrumb"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              style={{ marginBottom: 0 }}
            >
              <ol
                className="breadcrumb"
                style={{
                  background: "rgba(255, 255, 255, 1)",
                  borderRadius: 14,
                  padding: "12px 24px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  display: "flex",
                  gap: 8,
                  fontSize: 16,
                  fontWeight: 500,
                  marginBottom: 0,
                  alignItems: "center",
                  flexWrap: "wrap",
                  border: "1px solid #ffffffff",
                }}
              >
                <motion.li
                  className="breadcrumb-item"
                  whileHover={{ scale: 1.08, color: "#848484ff" }}
                  style={{ transition: "0.2s", marginRight: 4 }}
                >
                  <a
                    href="/"
                    style={{
                      color: "#848484ff",
                      textDecoration: "none",
                      fontWeight: 600,
                    }}
                  >
                    <span style={{ marginRight: 4, fontSize: 18 }}></span>
                    หน้าแรก
                  </a>
                </motion.li>
                <span
                  style={{ color: "#848484ff", fontSize: 20, margin: "0 4px" }}
                >
                  ›
                </span>
                <motion.li
                  className="breadcrumb-item"
                  whileHover={{ scale: 1.08, color: "#848484ff" }}
                  style={{ transition: "0.2s", marginRight: 4 }}
                >
                  <a
                    href="/services"
                    style={{
                      color: "#848484ff",
                      textDecoration: "none",
                      fontWeight: 600,
                    }}
                  >
                    <span style={{ marginRight: 4, fontSize: 20 }}></span>
                    บริการของเรา
                  </a>
                </motion.li>
                <span
                  style={{ color: "#ffb3b3", fontSize: 18, margin: "0 4px" }}
                >
                  ›
                </span>
                <motion.li
                  className="breadcrumb-item"
                  whileHover={{ scale: 1.08, color: "#848484ff" }}
                  style={{ transition: "0.2s", marginRight: 4 }}
                >
                  <a
                    href="/services"
                    style={{
                      color: "#ff7070ff",
                      textDecoration: "none",
                      fontWeight: 600,
                    }}
                  >
                    <span style={{ marginRight: 4, fontSize: 20 }}></span>
                    จัดทำเงินเดือน
                  </a>
                </motion.li>
              </ol>
            </motion.nav>
          </Col>
        </Row>
      </Container>
      <Container fluid="md">
        <Row className="justify-content-center" style={{ marginTop: 24 }}>
          <Col xs={120} md={110} lg={100} xl={90} xxl={80}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
            >
              <Card
                className="border-0 shadow-sm"
                style={{ borderRadius: 18, background: "#fff" }}
              >
                <Card.Body style={{ padding: 40, marginBottom: 32 }}>
                  <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.7, delay: 0.2 }}
                    className="d-flex align-items-center mb-3"
                  >
                    <FaGavel className="me-2" color=" #db3b3bff" size={28} />
                    <h2
                      className="fw-bold mb-0"
                      style={{ fontSize: 28, letterSpacing: 0.5 }}
                    >
                      บริการจัดทำเงินเดือน
                    </h2>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.7, delay: 0.4 }}
                    className="mb-4"
                    style={{
                      background: "#f3f4f6",
                      borderRadius: 12,
                      padding: 20,
                      marginBottom: 32,
                    }}
                  >
                    <blockquote
                      className="mb-0"
                      style={{
                        fontSize: 16,
                        color: "#555",
                        fontStyle: "italic",
                        borderLeft: "4px solid #db3b3bff",
                        paddingLeft: 16,
                      }}
                    >
                      "บริหารจัดการเงินเดือนและบุคลากรอย่างมืออาชีพ ถูกต้อง
                      แม่นยำ และเป็นความลับ"
                    </blockquote>
                  </motion.div>
                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.6 }}
                    className="mb-4"
                    style={{ fontSize: 17, color: "#222", lineHeight: 1.7 }}
                  >
                    การจ่ายเงินเดือนเป็นหนึ่งในงานที่สำคัญและละเอียดอ่อนที่สุดขององค์กร
                    เพราะเกี่ยวข้องโดยตรงกับขวัญและกำลังใจของพนักงาน
                    รวมถึงกฎหมายและข้อบังคับต่างๆ เช่น ประกันสังคมและภาษี
                    การใช้บริการจัดทำเงินเดือนจากภายนอก (Payroll Outsourcing)
                    ช่วยลดความซับซ้อน ลดความเสี่ยงจากความผิดพลาด
                    และรักษาข้อมูลเงินเดือนของพนักงานให้เป็นความลับสูงสุด
                  </motion.p>
                  <hr className="my-4" style={{ opacity: 0.15 }} />
                  <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.7 }}
                    className="mb-4"
                  >
                    <h4
                      className="fw-semibold mb-4 d-flex align-items-center"
                      style={{ color: "#db3b3bff", fontSize: 20 }}
                    >
                      <span className="me-2" role="img" aria-label="service">
                        📝
                      </span>{" "}
                      ขอบเขตการบริการของเรา
                    </h4>

                    {/* Service Item 1 */}
                    <div
                      className="mb-4"
                      style={{
                        background:
                          "linear-gradient(135deg, #fff5f5 0%, #fef2f2 100%)",
                        borderRadius: 8,
                        padding: 24,
                        border: "1px solid #ffffffff",
                        boxShadow: "0 4px 12px rgba(255, 255, 255, 0.08)",
                      }}
                    >
                      <h5
                        className="fw-bold mb-3 d-flex align-items-center"
                        style={{ color: "#dc2626", fontSize: 18 }}
                      >
                        <span
                          className="me-2"
                          style={{
                            background: "#dc2626",
                            color: "white",
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          1
                        </span>
                        การคำนวณเงินเดือนและค่าตอบแทน
                      </h5>
                      <ul
                        className="mb-0"
                        style={{ paddingLeft: 20, color: "#374151" }}
                      >
                        <li className="mb-2">
                          คำนวณเงินเดือน, ค่าล่วงเวลา (OT), ค่าคอมมิชชั่น,
                          และเงินได้อื่นๆ ของพนักงาน
                        </li>
                        <li className="mb-2">
                          คำนวณรายการหักต่างๆ เช่น ภาษีหัก ณ ที่จ่าย,
                          เงินสมทบประกันสังคม, กองทุนสำรองเลี้ยงชีพ
                          และรายการหักอื่นๆ
                        </li>
                      </ul>
                    </div>

                    {/* Service Item 2 */}
                    <div
                      className="mb-4"
                      style={{
                        background:
                          "linear-gradient(135deg, #fff5f5 0%, #fef2f2 100%)",
                        borderRadius: 8,
                        padding: 24,
                        border: "1px solid #ffffffff",
                        boxShadow: "0 4px 12px rgba(255, 255, 255, 0.08)",
                      }}
                    >
                      <h5
                        className="fw-bold mb-3 d-flex align-items-center"
                        style={{ color: "#dc2626", fontSize: 18 }}
                      >
                        <span
                          className="me-2"
                          style={{
                            background: "#dc2626",
                            color: "white",
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          2
                        </span>
                        การจัดทำรายงานและเอกสาร
                      </h5>
                      <ul
                        className="mb-0"
                        style={{ paddingLeft: 20, color: "#374151" }}
                      >
                        <li className="mb-2">
                          จัดทำรายงานสรุปเงินเดือนเพื่อการจ่ายเงิน
                        </li>
                        <li className="mb-2">
                          จัดทำสลิปเงินเดือน (Pay Slip)
                          ในรูปแบบกระดาษคาร์บอนหรือแบบอิเล็กทรอนิกส์ (e-Payslip)
                        </li>
                        <li className="mb-0">
                          จัดทำและนำส่งแบบ ภ.ง.ด.1
                          และแบบนำส่งเงินสมทบประกันสังคม (สปส. 1-10) ประจำเดือน
                        </li>
                      </ul>
                    </div>

                    {/* Service Item 3 */}
                    <div
                      className="mb-4"
                      style={{
                        background:
                          "linear-gradient(135deg, #fff5f5 0%, #fef2f2 100%)",
                        borderRadius: 8,
                        padding: 24,
                        border: "1px solid #ffffffff",
                        boxShadow: "0 4px 12px rgba(255, 255, 255, 0.08)",
                      }}
                    >
                      <h5
                        className="fw-bold mb-3 d-flex align-items-center"
                        style={{ color: "#dc2626", fontSize: 18 }}
                      >
                        <span
                          className="me-2"
                          style={{
                            background: "#dc2626",
                            color: "white",
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          3
                        </span>
                        การจัดการด้านประกันสังคมและกองทุนทดแทน
                      </h5>
                      <ul
                        className="mb-0"
                        style={{ paddingLeft: 20, color: "#374151" }}
                      >
                        <li className="mb-2">
                          ดำเนินการแจ้งเข้า-แจ้งออกของพนักงานกับสำนักงานประกันสังคม
                        </li>
                        <li className="mb-0">
                          จัดทำและนำส่งรายงานค่าจ้างประจำปี (กท.20)
                        </li>
                      </ul>
                    </div>

                    {/* Service Item 3 */}
                    <div
                      className="mb-4"
                      style={{
                        background:
                          "linear-gradient(135deg, #fff5f5 0%, #fef2f2 100%)",
                        borderRadius: 8,
                        padding: 24,
                        border: "1px solid #ffffffff",
                        boxShadow: "0 4px 12px rgba(255, 255, 255, 0.08)",
                      }}
                    >
                      <h5
                        className="fw-bold mb-3 d-flex align-items-center"
                        style={{ color: "#dc2626", fontSize: 18 }}
                      >
                        <span
                          className="me-2"
                          style={{
                            background: "#dc2626",
                            color: "white",
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          4
                        </span>
                        การจัดทำเอกสารสำหรับพนักงาน
                      </h5>
                      <ul
                        className="mb-0"
                        style={{ paddingLeft: 20, color: "#374151" }}
                      >
                        <li className="mb-2">
                          จัดทำหนังสือรับรองการหักภาษี ณ ที่จ่าย (50 ทวิ)
                          ให้กับพนักงานเมื่อสิ้นปีหรือเมื่อลาออก
                        </li>
                        <li className="mb-0">
                          ให้คำปรึกษาเบื้องต้นเกี่ยวกับกฎหมายแรงงานที่เกี่ยวข้องกับการจ่ายค่าจ้าง
                        </li>
                      </ul>
                    </div>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0 }}
                    className="mb-4"
                  >
                    <h4
                      className="fw-semibold mb-3 d-flex align-items-center"
                      style={{
                        color: "#db3b3bff",
                        fontSize: 24,
                        marginTop: 48,
                      }}
                    >
                      <span className="me-2" role="img" aria-label="price">
                        💸
                      </span>{" "}
                      ทำไมต้องเลือกบริการกฎหมายธุรกิจจากเรา?
                    </h4>
                    <ListGroup variant="flush">
                      <ListGroup.Item
                        style={{
                          background: "none",
                          border: 0,
                          paddingLeft: 0,
                          color: "#444",
                        }}
                      >
                        <span className="fw-bold"></span>
                      </ListGroup.Item>
                      <ListGroup.Item
                        style={{
                          background: "none",
                          border: 0,
                          paddingLeft: 0,
                          color: "#444",
                        }}
                      >
                        เราให้ความสำคัญสูงสุดกับ ความถูกต้อง ความตรงต่อเวลา และ
                        การรักษาความลับ
                        ทีมงานของเรามีความเชี่ยวชาญในกฎระเบียบที่เกี่ยวข้องและใช้ซอฟต์แวร์ที่ได้มาตรฐาน
                        ทำให้คุณมั่นใจได้ว่าพนักงานจะได้รับค่าตอบแทนที่ถูกต้องและตรงเวลาเสมอ
                        ช่วยลดภาระงานของฝ่ายบุคคลและสร้างความพึงพอใจให้กับพนักงานในองค์กร
                      </ListGroup.Item>
                    </ListGroup>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0 }}
                  >
                    <hr
                      style={{
                        border: "none",
                        borderTop: "2px solid #e0e0e0",
                        margin: "32px 0 24px 0",
                        marginBottom: "32px",
                        opacity: 0.7,
                      }}
                    />
                    <h4
                      className="fw-semibold mb-3 d-flex align-items-center"
                      style={{ color: "#db3b3bff", fontSize: 20 }}
                    >
                      <span className="me-2" role="img" aria-label="related">
                        🔗
                      </span>{" "}
                      บริการอื่นๆ
                    </h4>
                    <Row xs={1} md={3} className="g-3">
                      {randomServices.map((service, idx) => {
                        // กำหนดลิงก์สำหรับแต่ละบริการ
                        let link = "#";
                        switch (service.title) {
                          case "บริการจัดทำบัญชี":
                            link = "/services/accounting";
                            break;
                          case "บริการจัดทำเงินเดือน":
                            link = "/services/payroll";
                            break;
                          default:
                            link = "#";
                        }
                        return (
                          <Col key={idx}>
                            <a href={link} style={{ textDecoration: "none" }}>
                              <Card
                                className="h-100 shadow-sm card-hover"
                                style={{
                                  borderRadius: 18,
                                  background: `linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(220,38,38,0.08) 100%), url(${service.img}) center center/cover no-repeat`,
                                  border: "none",
                                  minHeight: 240,
                                  color: "#fff",
                                  position: "relative",
                                  boxShadow: "0 6px 24px rgba(220,38,38,0.10)",
                                  transition: "transform 0.2s, box-shadow 0.2s",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform =
                                    "translateY(-6px) scale(1.03)";
                                  e.currentTarget.style.boxShadow =
                                    "0 12px 32px rgba(220,38,38,0.18)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = "none";
                                  e.currentTarget.style.boxShadow =
                                    "0 6px 24px rgba(220,38,38,0.10)";
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    background: "rgba(98, 98, 98, 0.5)",
                                    borderRadius: 18,
                                    zIndex: 1,
                                  }}
                                ></div>
                                <Card.Body
                                  style={{
                                    position: "relative",
                                    zIndex: 2,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                  }}
                                >
                                  <Card.Title
                                    style={{
                                      color: "#ec3e3eff",
                                      fontWeight: 700,
                                      fontSize: 20,
                                      textAlign: "center",
                                      marginBottom: 12,
                                      letterSpacing: 0.5,
                                      textShadow:
                                        "0 2px 8px rgba(220,38,38,0.08)",
                                    }}
                                  >
                                    {service.title
                                      .split("\n")
                                      .map((line, idx) => (
                                        <React.Fragment key={idx}>
                                          {line}
                                          <br />
                                        </React.Fragment>
                                      ))}
                                  </Card.Title>
                                  <Card.Text
                                    style={{
                                      color: "#dcdcdcff",
                                      fontSize: 16,
                                      textAlign: "center",
                                      fontWeight: 500,
                                      lineHeight: 1.6,
                                    }}
                                  >
                                    {service.desc}
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            </a>
                          </Col>
                        );
                      })}
                    </Row>
                  </motion.div>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Payroll;
